<template>
  <div class='school-year fl' v-show='isShow'>
    <el-select size='small' style='width: 150px' v-model='year' class='m-r-30' clearable placeholder='所属学年'>
      <el-option v-for='item in years' :key='item.value' :label='item.label' :value='item.value'></el-option>
    </el-select>
    <el-select size='small' style='width: 150px' v-model='term' class='m-r-30' clearable placeholder='所属学期'>
      <el-option v-for='item in terms' :key='item.value' :label='item.label' :value='item.value'></el-option>
    </el-select>
    <el-select size='small' style='width: 150px' v-model='class_type' clearable placeholder='课程类型'>
      <el-option v-for='item in class_types' :key='item.value' :label='item.label' :value='item.value'></el-option>
    </el-select>
  </div>
</template>

<script>
import { Option, Select } from 'element-ui';

export default {
  components: { ElSelect: Select, ElOption: Option },
  data() {
    return {
      years: [],
      terms: [],
      class_types: [
        {
          value: -1,
          label: '全部'
        }, {
          value: 1,
          label: '线上班'
        },
        {
          value: 2,
          label: '线下班'
        }]
    };
  },
  mounted() {
    this.$store.dispatch('schoolYear/getTermAndYearList').then(list => {
      if (list) {
        let newTerm = list.term;
        if (list.term[list.term.length - 1].value === 6) {
          const dong = list.term.find(item => item.value === 6);
          newTerm = list.term.filter(item => item.value !== 6);
          newTerm.splice(3, 0, dong);
        }
        this.years = [{ label: '全部', value: -1 }, ...list.year];
        this.terms = [{ label: '全部', value: -1 }, ...newTerm];
      }
    });
  },
  computed: {
    year: {
      get() {
        return this.$store.state.schoolYear.year;
      },
      set(value) {
        this.$store.dispatch('schoolYear/changeYear', value);
      }
    },
    term: {
      get() {
        return this.$store.state.schoolYear.term;
      },
      set(value) {
        this.$store.dispatch('schoolYear/changeTerm', value);
      }
    },
    class_type: {
      get() {
        return this.$store.state.schoolYear.classType;
      },
      set(value) {
        this.$store.dispatch('schoolYear/changeClassType', value);
      }
    },
    isShow() {
      return this.$store.state.schoolYear.isShow;
    }
  }
};
</script>

<style lang='less'>
.school-year {
  height: @navBarTopHeight;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
